<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title jpn="特定商取引法に基づく表記" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">運営会社名称</span>
            <span class="text">株式会社ゼロプレイス</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">代表責任者</span>
            <span class="text">成田 優樹</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">会社登記住所・営業所住所</span>
            <span class="text">〒330-0854</span>
            <span class="text">埼玉県さいたま市大宮区桜木町1丁目195‑1</span>
            <span class="text">大宮ソラミチKOZ4階</span>

          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">電話番号</span>
            <span class="text">050-1724-5360</span>
            <span class="text">( ※受付時間 : 平日10時-17時 )</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">メールアドレス</span>
            <span class="text">support@xeroplace.jp</span>
            <span class="text">※お問い合わせは、サイト内のチャットよりお願いいたします。原則2営業日以内にはお返事いたします。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">価格</span>
            <span class="text">各商品毎に表示</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">商品代金以外の必要料金</span>
            <span class="text">当社の提供するサービスを利用するための機器に関する費用、インターネット接続料金、パケット通信料、消費税、代金支払いの振込手数料</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">引渡時期</span>
            <span class="text">申込受付時</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">販売数量</span>
            <span class="text">特に指定はございません。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">お支払い方法</span>
            <span class="text">クレジットカード・コンビニエンスストア・PayPal・キャリア決済・PayPay・メルペイ・AmazonPayとなります。</span>
            <span class="text">※ご決済後のお客様都合によるキャンセルは承ることができません。予めご容赦ください。</span>
            <span class="text">期限までにお支払いがない場合、自動的にキャンセルとなります。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">支払時期</span>
            <span class="text">クレジットカード：クレジットカード会社の規約に基づく。</span>
            <span class="text">コンビニ決済：ご注文日から３日以内に代金をお支払いください。</span>
            <span class="text">PayPal：PayPalの規約に基づく。</span>
            <span class="text">キャリア決済：各キャリアの規約に基づく。</span>
            <span class="text">PayPay：PayPayの規約に基づく。</span>
            <span class="text">メルペイ：メルペイの規約に基づく。</span>
            <span class="text">Amazonpay：Amazonpayの規約に基づく。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">返品特約と期限</span>
            <span class="text">サービスの性質上、返品・返金はお受けしておりません。</span>
            <span class="text">ただし、弊社に100％過失がある場合はご対応させてただきます。</span>
            <span class="text">以下の場合はご対応いたしかねます。予めご容赦くださいませ。</span>
            <span class="text">配送過程での紛失や損傷等が生じてしまった場合</span>
            <span class="text">BOX等未開封品の動画撮影等が無い場合</span>
            <span class="text">※再シュリンク品の検品は特に留意しておこなわせていただいております。</span>
            <span class="text">商品ご到着後、10日を超えた場合</span>
            <span class="text">PSAなどの鑑定品に傷等が見受けられてしまい、それを理由とした交換・返品依頼を承った場合</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">古物商営業許可</span>
            <span class="text">第431370066203</span>
            <span class="text">株式会社ゼロプレイス</span>
            <span class="text">埼玉県公安委員会</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),

  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1000px;
  padding: 30px 20px 0;
  margin: 0 auto;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.none{
            color: red;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 100%;
  th, td {
    font-size: 16px;
    color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
    width: 200px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .specific-commerce{
    .scroll-container{
      .shadow-box-title-description{
        .text-container{
          .text{
            font-size: 14px;
          }
        }
      }
    }
  }
  table.code {
    width: 100%;
    th, td {
      display: block;
      font-size: 14px;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
